import { ICommand, IDefineCommand, IQuery, IQueryMediator } from 'core-ts-types';
import { AppointmentsAvailableTimesDatasource } from '../datasources/appointments_available_times_datasource';

angular
  .module('capability-ng-appointments')
  .factory(
    'AppointmentsTimeSelectionChangeCommand',
    (
      defineCommand: IDefineCommand,
      $http: ng.IHttpService,
      QueryMediator: IQueryMediator,
      ngAppointmentsAvailableTimesDatasource: AppointmentsAvailableTimesDatasource
    ): ICommand => {
      return defineCommand('AppointmentsTimeSelectionChangeCommand', (deferred: ng.IDeferred<any>, item: any): void => {
        ngAppointmentsAvailableTimesDatasource.setSelectedTime(item);
        deferred.resolve(QueryMediator.runQueries(ngAppointmentsAvailableTimesDatasource));
      });
    }
  );



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-appointments/src/commands/appointments_time_selection_change_command.ts